import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Quay lại',
      changePassword: 'Thay đổi',
      copiedVaultId: 'Đã sao chép!',
      copyVaultID: 'Sao chép mã Vault',
      create: 'Tạo',
      next: 'Tiếp',
      notSure: 'Tôi không chắc',
      signUp: 'Đăng ký',
      submit: 'Gửi',
      updatePassword: 'Cập nhật mật khẩu',
    },
    Errors: {
      createReportFailed: 'Tạo báo cáo không thành công.',
    },
    ReportStatus: {
      CLOSED: 'Đã đóng',
      INVESTIGATING: 'Đang điều tra',
      NEW: 'Đã gửi',
      READ: 'Đã đọc',
    },
    general: {
      navbar: {
        caseSettings: 'Cài đặt trường hợp',
        changePassword: 'Đổi mật khẩu',
        logOut: 'Đăng xuất',
        notifications: 'Thông báo',
        notificationsDrawer: {
          appFileScanFailed: 'Một tệp đã không qua được kiểm tra an ninh',
          appReportMatch: 'Hồ sơ GoTogether của bạn đã được khớp',
          appReportReassigned: 'Một người quản lý hồ sơ mới đã được giao',
          case: 'Trường hợp',
          caseAssigned: 'Trường hợp được giao cho bạn',
          caseImporterJobCompleted: {
            PartialSuccess: 'Trường hợp nhập của bạn đã hoàn tất với lỗi',
            failure: 'Việc nhập dữ liệu cho trường hợp của bạn đã thất bại',
            success: 'Trường hợp nhập khẩu của bạn đã hoàn tất thành công',
          },
          caseLinked: 'Trường hợp liên kết',
          caseTeamInvite: 'Đã thêm vào trường hợp',
          caseUnlinked: 'Trường hợp không liên kết',
          dataSanitisation: 'Chi tiết báo cáo được cập nhật',
          emptyDescription: 'Kiểm tra lại sau để nhận thông báo mới',
          emptyTitle: 'Bạn đã cập nhật đầy đủ',
          importId: 'ID Nhập khẩu:',
          learnMore: 'Tìm hiểu thêm',
          markAllAsRead: 'Đánh dấu tất cả là đã đọc',
          newMessage: 'Tin nhắn mới',
          newReport: 'Đã nhận được báo cáo mới',
          permissionRemoved: 'Đã loại bỏ khỏi trường hợp',
          postSSubmissionFile: 'Tệp chứng cứ đã được thêm vào',
          report: 'Báo cáo',
          reportAssigned: 'Báo cáo được giao cho bạn',
          reportStatusChange: 'Trạng thái báo cáo đã thay đổi',
          reporterAnonymised: 'Chi tiết của bạn đã được ẩn danh',
          reporterReportSubmitted: {
            subtitle:
              'Chúng tôi khuyến nghị lưu một bản sao của báo cáo của bạn',
            title: 'Báo cáo đã được nộp',
          },
          mitigationPlanReminder: 'Yêu cầu phê duyệt kế hoạch giảm thiểu',
          staleCase: 'Trường hợp không được xử lý',
        },
        privacyStatement: 'Tuyên bố về quyền riêng tư',
        reporter: {
          myReports: 'Báo cáo của tôi',
        },
        settings: 'Cài đặt',
        technicalSupport: 'Hỗ trợ kỹ thuật',
        title: 'Tài khoản',
      },
      time: {
        day: 'Ngày',
        days: 'Ngày',
        hour: 'Giờ',
        hours: 'Giờ',
        minute: 'Phút',
        minutes: 'Phút',
        second: 'Giây',
        seconds: 'Giây',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Ẩn danh',
        autoTranslate: 'Chế độ dịch tự động được tắt theo mặc định.',
        backToMessages: 'Quay lại tin nhắn',
        caseSettings: 'Thiết lập trường hợp.',
        changeInProfile:
          'Nếu bạn muốn thay đổi cài đặt này, bạn có thể làm điều đó trong hồ sơ của bạn',
        deletedByMessage: 'Đã xóa bởi {{author}}',
        deletedMessageLabel: 'Tin nhắn này đã bị xóa',
        description:
          'Khi chế độ dịch tự động được bật, tất cả các tin nhắn báo cáo sẽ được\n          tự động dịch bằng AI dựa trên ngôn ngữ mặc định\n          đã chọn trên trình duyệt của bạn.',
        descriptionSecondHalf:
          'Phiên bản gốc của tất cả các tin nhắn luôn được bảo quản và có thể tìm thấy trong cuộc trò chuyện.',
        messagePlaceholder: 'Bắt đầu nhập...',
        messageSettings: 'Cài đặt tin nhắn.',
        originalMessages: 'Nguyên bản.',
        showMoreBanner: 'Tìm hiểu thêm về dịch tự động',
        titlev2: 'Đọc tất cả các tin nhắn bằng ngôn ngữ ưa thích của bạn.',
        translatedMessageLabel: 'Thông điệp đã dịch',
        translatedMessages: 'Dịch',
        understood: 'Đã hiểu',
      },
      Country: {
        description: 'Bạn đang làm việc tại quốc gia nào?',
        header: 'Bạn đang làm việc tại quốc gia nào?',
        noOptions: 'Không tìm thấy quốc gia nào',
        other: 'Khác',
        placeholder: 'Tìm kiếm quốc gia...',
      },
      CreatePublicReport: {
        createReport: 'Tạo báo cáo',
        helpPage: 'Truy cập trang trợ giúp của chúng tôi',
        loginToOpr: 'Đăng Nhập để Theo Dõi Báo Cáo',
        or: 'hoặc',
        passwordPlaceholder: 'Nhập Mật Khẩu',
        phoneNumberLoginFailed:
          'Đăng nhập không thành công, số điện thoại/mã PIN không chính xác',
        phoneNumberPlaceholder: 'Nhập Số Điện Thoại của bạn',
        phoneNumberTooltip:
          'Nhập số điện thoại bạn đã sử dụng để liên hệ với VaultTalk',
        pinPlaceholder: 'Nhập mã PIN',
        reportIntroductionParagraph1:
          'Khi báo cáo sự cố, bạn sẽ được hỏi một vài câu hỏi để hỗ trợ ghi lại trải nghiệm của mình.',
        reportIntroductionParagraph2:
          'Trước khi gửi, bạn có thể chọn ẩn danh để bảo vệ quyền riêng tư của mình.',
        reportIntroductionParagraph3:
          'Sau khi gửi, bạn có thể đăng nhập bất cứ lúc nào để xem tiến độ báo cáo của mình & trao đổi với người quản lý vụ việc.',
        reportIssue: 'Báo cáo sự cố',
        usernameLoginFailed:
          'Đăng nhập không thành công, tên người dùng/mật khẩu không chính xác',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired:
              'Mối quan hệ với công ty là bắt buộc',
            reportedCategoryRequired: 'Yêu cầu phải báo cáo danh mục',
          },
        },
        vaultId: 'Mã Vault',
        vaultIdPlaceholder: 'Nhập Email hoặc Mã Vault của bạn',
        vaultIdTooltip:
          'Đối với các báo cáo ẩn danh, mã Vault bao gồm chữ và số. Nếu báo cáo không ẩn danh, mã Vault là địa chỉ email của bạn',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Mật Khẩu của bạn',
        yourPhoneNumber: 'Số Điện Thoại của bạn',
        yourPin: 'Mã PIN 6 Chữ Số của bạn',
        yourVaultId: 'Vault ID của bạn',
      },
      CustomHeader: {
        companyLogo: 'Biểu tượng {{company}}',
        openReporting: 'Báo Cáo Mở',
        userSettings: 'Cài Đặt Người Dùng',
      },
      Date: {
        approximateDescription:
          'Bạn có nhớ ngày gần đúng diễn ra sự kiện không?',
        approximatePlaceholder:
          'Ví dụ: 6 tháng trước / năm ngoái / tháng 11 năm ngoái',
        cancel: 'hủy',
        clear: 'xóa',
        description: 'Bạn có nhớ ngày diễn ra sự kiện không?',
        header: 'Chuyện đó đã diễn ra vào ngày nào?',
        ok: 'ok',
        placeholder: 'Ví dụ: ngày 21 tháng 6 năm 2020',
      },
      Description: {
        whatHappened: 'Chuyện gì đã xảy ra?',
        whatHappenedPlaceholder: 'Sử dụng cách diễn đạt của riêng bạn...',
        whatHappenedText:
          'Bằng cách diễn đạt của riêng bạn, hãy mô tả những gì đã xảy ra',
      },
      Details: {
        disclaimer:
          'Những chi tiết này sẽ được tiết lộ cùng với báo cáo của bạn. Nếu bạn muốn ẩn danh, hãy đảm bảo chúng không chứa thông tin nhận dạng.',
        emailPlaceholder: 'Email (không bắt buộc)',
        fullNamePlaceholder: 'Họ Tên (không bắt buộc)',
        header: 'Thông tin của bạn',
        nonAnonSubtitle:
          'Vui lòng cung cấp tên của bạn hoặc địa chỉ email. Nếu bạn muốn nhận thông báo về báo cáo này, hãy thêm địa chỉ email phù hợp bên dưới.',
        nonOptionalEmailPlaceholder: 'Email',
        nonOptionalFullNamePlaceholder: 'Tên đầy đủ',
        subtitle:
          'Nếu bạn muốn nhận thông báo về báo cáo này, hãy thêm một địa chỉ email thích hợp bên dưới.',
      },
      Emotion: {
        description: 'Điều đó khiến bạn cảm thấy như thế nào? Có ảnh hưởng gì?',
        header: 'Chuyện đó đã có ảnh hưởng gì?',
        placeholder: 'Bắt đầu nhập...',
      },
      Evidence: {
        addedHeading: 'Đã thêm',
        deletedMessage: 'đã bị xóa',
        deletedStatus: 'Đã xóa',
        failedToOpenFileMessage: 'Không thể mở tệp. Vui lòng thử lại',
        fileStatuses: {
          infectedUpload: 'Được đánh dấu bởi kiểm tra bảo mật',
          passedUpload: 'Đã vượt qua kiểm tra bảo mật',
          pendingUpload: 'Đang tiến hành kiểm tra bảo mật',
          readyForDownload: 'Sẵn sàng để tải xuống',
        },
        mobileErrorMessage:
          'Tệp được đánh dấu: nhắn tin cho người quản lý vụ việc của bạn',
        nameHeading: 'Tên',
        statusHeading: 'Trạng thái',
        tableTitle: 'Bằng chứng',
        webErrorMessage:
          'Tệp được đánh dấu: Nếu (các) tệp của bạn đã được đánh dấu, vui lòng nhắn tin cho người quản lý vụ việc',
      },
      FileUpload: {
        addFiles: 'Thêm tệp',
        addMoreFiles: 'Thêm tệp khác',
        confirm: 'Xác nhận',
        description:
          'Việc thêm tệp làm bằng chứng có thể giúp hỗ trợ hiệu quả giải quyết của người quản lý vụ việc của bạn. Vui lòng xem xét nội dung tệp (bao gồm siêu dữ liệu tệp) nếu bạn muốn ẩn danh và tôn trọng các quyền của cá nhân khác và tuân thủ luật hiện hành.',
        dragDrop: 'Thả tệp ở đây hoặc',
        errorMessage:
          '(Các) tệp không thành công do lỗi mạng. Nhấp vào bên dưới để nhắn tin cho người quản lý vụ việc của bạn để được hỗ trợ',
        fileLimit: 'Giới hạn kích thước mỗi tệp: 100MB',
        fileUploadLimitText: 'Bạn chỉ có thể tải lên 10 tệp',
        header: 'Thêm bằng chứng',
        helpArticle: 'bài viết trợ giúp',
        highlighted: 'duyệt các tệp',
        information: 'Các loại tệp được hỗ trợ',
        moreInformation:
          'Để biết thêm thông tin, vui lòng xem cái này <a>bài viết trợ giúp</a>',
        postSubmissionErrorMessage:
          'Chúng tôi không thể tải tệp của bạn lên do lỗi hệ thống. Vui lòng chọn lại "xác nhận".',
        tooltipAudio: 'Âm thanh:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Tài liệu:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Hình ảnh:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Văn bản:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Tệp quá lớn',
          invalidFileType: 'Loại tệp không được hỗ trợ: {{extension}}',
          systemError: 'Lỗi hệ thống',
          tooManyFiles: 'Số lượng tệp tối đa là {{maxFiles}}',
        },
        uploadFiles: 'Tải tệp lên',
      },
      Loading: {
        loading:
          'Vui lòng đợi trong khi chúng tôi gửi báo cáo của bạn cho người quản lý vụ việc...',
        postSubmissionLoading:
          'Vui lòng đợi trong khi chúng tôi gửi (các) tệp của bạn...',
      },
      Location: {
        description: 'Chuyện đó đã xảy ra ở đâu?',
        header: 'Chuyện đó đã xảy ra ở đâu?',
        placeholder: 'Ví dụ: Trong văn phòng',
      },
      MessageListBox: {
        messageCaseManager: 'Nhắn tin cho người quản lý vụ việc',
        report: 'Báo cáo {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Dịch vụ dịch thuật đã bị vô hiệu hóa',
        enableTranslationLabelEnabled: 'Dịch đã được kích hoạt',
        enableTranslationsDescription:
          'Kích hoạt dịch tự động và đọc tất cả các thông báo báo cáo bằng ngôn ngữ ưa thích của bạn. Ngôn ngữ dịch dựa trên ngôn ngữ đã chọn trên thiết bị của bạn.',
        enableTranslationsHeader:
          'Kích hoạt tự động dịch cho các tin nhắn báo cáo',
        enableTranslationsSubDescriptionv2:
          'Bạn có thể chuyển đổi giữa ngôn ngữ dịch và ngôn ngữ gốc trong mỗi cuộc trò chuyện.',
        updateTranslationFailed: 'Cập nhật dịch bản thất bại',
        updateTranslationSuccess: 'Cập nhật cài đặt dịch thành công',
      },
      Password: {
        changePasswordHeader: 'Thay đổi',
        createNewPassword: 'Vui lòng tạo mật khẩu mới',
        createPasswordHeader: 'Mật Khẩu của bạn',
        currentPasswordPlaceholder: 'Nhập mật khẩu hiện tại',
        description:
          'Mật khẩu hợp lệ phải dài ít nhất 9 ký tự và bao gồm một chữ cái viết hoa và một số',
        enterCurrentPassword: 'Vui lòng nhập mật khẩu hiện tại của bạn',
        forgottenPasswordInstructions:
          'Nhập ID Vault dạng chữ và số của bạn (không phải địa chỉ email) và địa chỉ email để đặt lại mật khẩu.',
        newDescription:
          'Tạo một mật khẩu mạnh để giữ tài khoản của bạn an toàn. Bắt đầu gõ để xem hướng dẫn bên dưới.',
        passwordPlaceholder: 'Tạo mật khẩu',
        passwordResetRequestedDescription:
          'Nếu ID Vault của bạn tồn tại trong hệ thống của chúng tôi, bạn sẽ nhận được một email với hướng dẫn để đặt lại mật khẩu của bạn.',
        passwordResetRequestedHeader: 'Đã yêu cầu liên kết đặt lại mật khẩu',
        reenterPlaceholder: 'Nhập lại mật khẩu',
        subtitle: 'Tạo mật khẩu để gửi báo cáo này và truy cập trong tương lai',
        yourVaultId: 'ID Vault của bạn',
        yourVaultIdPlaceholder: 'Nhập ID Vault của bạn (ví dụ: {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Bạn đang báo cáo một người cụ thể hay nhiều người? Bạn có thể nêu tên hoặc mô tả họ không?',
        header: 'Những người tham gia',
        placeholder:
          'Bắt đầu nhập và sử dụng dấu phẩy để thêm nhiều tên hoặc mô tả',
      },
      PoweredByVault: 'Được cung cấp bởi {{company}}',
      PrivacyStatement: 'Tuyên bố về Quyền riêng tư Sản phẩm',
      PublicMessageList: {
        myMessages: 'Tin nhắn của tôi',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Đã thêm bằng chứng vào báo cáo hiện có',
        backToReportId: 'Quay lại ID báo cáo: {{reportId}}',
        description:
          'Việc thêm tệp làm bằng chứng có thể giúp hỗ trợ hiệu quả giải quyết của người quản lý vụ việc của bạn. Vui lòng xem xét nội dung tệp (bao gồm siêu dữ liệu tệp) nếu bạn muốn ẩn danh và tôn trọng các quyền của cá nhân khác và tuân thủ luật hiện hành. Để biết thêm thông tin, vui lòng xem cái này <a>bài viết trợ giúp</a>',
        header: 'Thêm bằng chứng bổ sung vào báo cáo',
        vaultTalkOpenCaseHeader: 'Thêm bằng chứng vào báo cáo của bạn',
      },
      PublicReport: {
        anonymous: 'Ẩn danh',
        backToReports: 'Quay lại báo cáo',
        skipped: 'Đã bỏ qua',
      },
      PublicReportCard: {
        addEvidence: 'Thêm bằng chứng bổ sung',
        messageCaseManager: 'Nhắn tin cho người quản lý vụ việc',
        reportId: 'Mã báo cáo:',
        submitted: 'Đã gửi',
        vaultTalkClosedCaseCTA: 'Xem bằng chứng',
        vaultTalkOpenCaseCTA: 'Thêm bằng chứng',
        viewAdditionalEvidence: 'Xem bằng chứng bổ sung',
        viewReport: 'Xem Báo Cáo',
      },
      PublicReportsList: {
        reportingSystem: 'Hệ Thống Báo Cáo',
      },
      Question: {
        placeholder: 'Bắt đầu nhập...',
        question: 'Cung cấp thông tin chi tiết',
        questionText:
          'Vui lòng chia sẻ mối lo ngại, cập nhật hoặc thắc mắc của bạn với chúng tôi',
      },
      Relationship: {
        header: 'Mối quan hệ của bạn với tổ chức',
        tellUsAbout:
          'Vui lòng cho chúng tôi biết về mối quan hệ của bạn với tổ chức.',
      },
      ResponsiveNavMenu: {
        messages: 'Tin nhắn của tôi',
        reports: 'Báo cáo của tôi',
      },
      Site: {
        description: 'Bạn đang làm việc tại địa điểm nào?',
        header: 'Bạn đang làm việc tại địa điểm nào?',
        noOptions: 'Không tìm thấy địa điểm',
        other: 'Khác',
        placeholder: 'Tìm kiếm địa điểm...',
      },
      SpamPuzzle: {
        dialog: 'Để tiếp tục, vui lòng giải câu đố này',
      },
      SubmissionTypes: {
        reportIssue: 'Chọn một danh mục',
        whatType: 'Chọn danh mục mô tả đúng nhất báo cáo của bạn',
      },
      SubmitSuccess: {
        category: '<bold>Danh mục:</bold> {{category}}',
        country: '<bold>Quốc gia:</bold> {{country}}',
        dateSubmitted: '<bold>Ngày nộp:</bold> {{date}}',
        recordYourVaultID: 'Ghi nhớ thông tin này để đăng nhập',
        successInformation: 'Thêm thông tin',
        successMessage:
          'Báo cáo của bạn đã được gửi và sẵn sàng để xem xét. Mọi tệp đính kèm cần chú ý sẽ được đánh dấu khi đăng nhập. Đăng nhập bên dưới để xem các cập nhật báo cáo và nhắn tin cho người quản lý vụ việc của bạn.',
        successSanitationMessage:
          'Lưu một bản sao cho hồ sơ của bạn, và giữ an toàn Vault-ID của bạn - bạn sẽ cần nó để truy cập cập nhật và gửi tin nhắn cho người quản lý trường hợp của bạn.',
        successSanitationTagline:
          'Báo cáo của bạn đã được gửi và lưu trữ an toàn.',
        successThankYou: 'Cảm ơn bạn đã báo cáo!',
        viewReport: 'Xem báo cáo',
      },
      Time: {
        approximateDescription:
          'Bạn có nhớ thời gian gần đúng của sự kiện không?',
        approximatePlaceholder: 'Ví dụ: vào buổi sáng, vào buổi chiều',
        description: 'Bạn có nhớ thời gian diễn ra sự kiện không?',
        header: 'Chuyện đó đã xảy ra vào lúc mấy giờ?',
        invalidTime: 'Định dạng thời gian phải là HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Thay đổi mật khẩu',
        closeDialog: 'Đóng Hộp Thoại',
        logout: 'Đăng xuất',
        messageSettings: 'Cài đặt tin nhắn',
        userSettings: 'Cài Đặt Người Dùng',
      },
      Witnesses: {
        description:
          'Bạn có kể với ai khác hoặc có ai chứng kiến ​​chuyện đã xảy ra không?',
        header: 'Có nhân chứng nào không?',
        placeholder: 'Bắt đầu nhập...',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Gửi tin nhắn',
        title: 'Trường hợp quản lý tin nhắn',
        translationHeader: 'Tìm hiểu thêm về dịch tự động',
      },
      ReportCard: {
        addEvidence: 'Thêm bằng chứng',
        submissionModeVia: 'qua {{submissionMode}}',
        viewEvidence: 'Xem bằng chứng',
      },
      ReportList: {
        yourReports: 'Báo cáo của bạn',
      },
      ReportingActivate: {
        buttonText: 'Tiếp tục',
        description:
          'Nếu tổ chức của bạn đã đăng ký cho bạn một tài khoản, chúng tôi sẽ gửi cho bạn một email với hướng dẫn để hoàn tất việc thiết lập.',
        emailInput: 'Email',
        header: 'Nhập email công việc của bạn',
        successAccount:
          'Nếu tổ chức của bạn đã đăng ký cho bạn một tài khoản, chúng tôi sẽ gửi cho bạn một email với hướng dẫn để hoàn tất việc thiết lập.',
        successEmail:
          'Nếu bạn không thấy nó ngay lập tức, vui lòng đợi một vài phút và làm mới hộp thư đến của bạn.',
        successHeading: 'Cảm ơn bạn',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Thêm bằng chứng vào báo cáo của bạn',
        descriptionText:
          'Việc thêm tệp tin như chứng cứ có thể giúp hỗ trợ hiệu suất giải quyết của người quản lý trường hợp của bạn. Vui lòng xem xét nội dung tệp (bao gồm cả metadata của tệp) nếu bạn muốn giữ ẩn danh, và tôn trọng quyền riêng tư của người khác và các luật pháp áp dụng. Để biết thêm thông tin, vui lòng xem <a>bài viết hướng dẫn</a> này',
        emptyMessage: 'Không có bằng chứng bổ sung nào được tải lên',
      },
      ReportingChangePassword: {
        back: 'Quay lại',
        description:
          'Tạo một mật khẩu mạnh để giữ tài khoản của bạn an toàn. Bắt đầu gõ để xem hướng dẫn bên dưới.',
        errorToast: 'Không thể tạo mật khẩu, mã token không hợp lệ.',
        header: 'Đổi Mật khẩu',
        incorrectCurrentPassword:
          'Mật khẩu hiện tại không chính xác. Vui lòng kiểm tra lại và thử lại.',
        invalidToken: 'Token không hợp lệ',
        passwordUpdated: 'Mật khẩu đã được cập nhật',
        passwordUpdatedDescription:
          'Mật khẩu của bạn đã được cập nhật thành công. Cảm ơn bạn đã thực hiện bước này để giữ an toàn cho dữ liệu của bạn!',
        passwordUsedBefore: 'Không được phép sử dụng lại mật khẩu',
        passwordUsedBeforeDescription:
          'Vì sự an toàn của bạn, bạn không thể sử dụng lại bất kỳ mật khẩu nào trong số sáu mật khẩu cuối cùng của mình. Vui lòng chọn một mật khẩu mới, độc đáo để giữ tài khoản của bạn an toàn và thử lại.',
        toastDescription:
          'Mật khẩu của bạn đã được cập nhật thành công. Cảm ơn bạn đã thực hiện bước này để bảo vệ dữ liệu của mình!',
        toastMessage: 'Mật khẩu đã được cập nhật',
        updatePasswordCTA: 'Cập nhật mật khẩu',
      },
      ReportingConnect: {
        cancelButton: 'Hủy',
        connectButton: 'Kết nối',
        disclaimer:
          'Kết nối tài khoản Slack của bạn với tài khoản Vault đảm bảo một kết nối an toàn và riêng tư.<br /><br />Bằng cách kết nối, bạn có thể báo cáo hành vi sai phạm hoặc đặt câu hỏi trực tiếp trong Slack. Bạn luôn có tùy chọn báo cáo ẩn danh sau khi kết nối. Sự riêng tư và an ninh của bạn là ưu tiên hàng đầu của chúng tôi.',
        heading:
          'Vault Platform đang yêu cầu quyền truy cập vào tài khoản Slack {{organisationName}} của bạn',
        listHeading: 'Vault sẽ có thể làm gì?',
        permissionIdentity: {
          extraInfo:
            'Vault sẽ có khả năng xem danh tính người dùng Slack của bạn',
          heading: 'Xem thông tin về danh tính của một người dùng',
        },
        permissionNotifications: {
          extraInfo:
            'Vault sẽ có thể gửi thông báo đến tài khoản Slack của bạn, liên quan đến bất kỳ cập nhật nào cho một báo cáo hoặc câu hỏi đã được gửi.',
          heading: 'Gửi cho bạn thông báo',
        },
        permissionOverview: {
          extraInfo:
            'Vault sẽ hiển thị tổng quan về tất cả các bài đăng trên trang chủ',
          heading: 'Tổng quan về các bài nộp',
        },
        permissionSubmitReport: {
          extraInfo:
            'Điều này sẽ cấp quyền cho Vault để gửi một báo cáo hoặc đặt một câu hỏi, trực tiếp đến tổ chức của bạn, từ Slack',
          heading: 'Gửi một báo cáo hoặc câu hỏi thay mặt bạn',
        },
        successfulConnectionDescription:
          'Tài khoản Vault và tài khoản Slack của bạn đã được kết nối. Bây giờ bạn có thể đóng tab này và quay lại Slack.',
        successfulConnectionHeading: 'Đã kết nối thành công',
        unsuccessfulConnectionDescription:
          'Đã xảy ra lỗi. Vui lòng đóng tab này và quay trở lại Slack để thử lại.',
        unsuccessfulConnectionHeading: 'Kết nối thất bại',
      },
      ReportingForgotPassword: {
        description:
          'Nhập địa chỉ email liên kết với tài khoản của bạn, và chúng tôi sẽ gửi cho bạn một liên kết để đặt lại mật khẩu.',
        heading: 'Quên mật khẩu',
        invalidTokenError: 'Không thể tạo mật khẩu, mã thông báo không hợp lệ.',
        passwordReuseError: 'Không cho phép sử dụng lại mật khẩu',
        passwordReuseErrorDescription:
          'Để đảm bảo an toàn, bạn không thể sử dụng lại bất kỳ mật khẩu nào trong số sáu mật khẩu gần đây nhất của mình. Hãy chọn một mật khẩu mới, độc đáo để giữ tài khoản của bạn an toàn và thử lại.',
        sendLink: 'Gửi liên kết đặt lại',
        sendLinkFailure: 'Đã xảy ra lỗi',
        sendLinkFailureDescription:
          'Quay lại <a>Trung tâm Báo cáo</a> và thử lại. Nếu sự cố vẫn tiếp tục, hãy liên hệ với chúng tôi tại <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Đã gửi liên kết đặt lại mật khẩu',
        sendLinkSuccessDescription:
          'Chúng tôi đã gửi một liên kết đặt lại mật khẩu đến {{email}}',
        updatePasswordSuccess: 'Mật khẩu đã được cập nhật',
        updatePasswordSuccessDescription:
          'Mật khẩu của bạn đã được cập nhật thành công. Cảm ơn bạn đã thực hiện bước này để giữ dữ liệu của bạn an toàn!',
      },
      ReportingLogin: {
        accountFrozen: 'Tài khoản đã bị đóng băng',
        accountLocked:
          'Đăng nhập đã được thử quá nhiều lần không chính xác. Tài khoản đã bị khóa trong vòng lên đến 1 giờ. Không thể đặt lại mật khẩu trong thời gian này',
        accountLockedPermanently:
          'Tài khoản của bạn đã bị khóa. Sử dụng chức năng đặt lại mật khẩu để lấy lại quyền truy cập hoặc liên hệ với quản trị viên hệ thống của bạn để được hỗ trợ thêm.',
        createAccountCTA: 'Đăng ký một tài khoản',
        currentPassword: 'Mật khẩu hiện tại',
        emailLabel: 'Email của bạn',
        forgotPassword: 'Quên mật khẩu của bạn?',
        loginButton: 'Đăng nhập',
        newPasswordPlaceholder: 'Mật khẩu mới',
        passwordFailMessage:
          'Quay lại Ứng dụng Vault trên Slack và thử lại. Nếu vấn đề vẫn tiếp diễn, hãy liên hệ với chúng tôi tại techsupport@vaultplatform.com',
        passwordFailTitle: 'Đã xảy ra lỗi',
        passwordLabel: 'Mật khẩu của bạn',
        passwordPlaceholder: 'Nhập mật khẩu của bạn',
        passwordResetRequired: 'Yêu cầu đặt lại mật khẩu',
        passwordSuccessfullySetMessage:
          'Quay lại Ứng dụng Vault trên Slack và xác thực bằng mật khẩu mới của bạn để tiếp tục nơi bạn đã dừng lại.',
        passwordSuccessfullySetTitle: 'Đặt mật khẩu thành công',
        reenterPlaceholder: 'Nhập lại mật khẩu',
        title: 'Trung tâm Phóng viên',
        tooltip:
          'Nếu bạn chưa từng đặt mật khẩu cho ứng dụng Vault, hãy theo đây để bắt đầu. Nếu bạn đã quên mật khẩu của mình, hãy sử dụng liên kết "Quên mật khẩu" bên dưới.',
        usernameLoginFailed:
          'Đăng nhập thất bại, tên đăng nhập hoặc mật khẩu không chính xác',
      },
      ReportingReset: {
        failureDescription:
          'Quay lại Ứng dụng Vault trong Slack và thử lại. Nếu vấn đề tiếp tục, hãy liên hệ với chúng tôi tại <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Đã xảy ra lỗi',
        successDescription:
          'Quay trở lại Ứng dụng Vault trong Slack và xác thực bằng mật khẩu mới của bạn để tiếp tục từ nơi bạn đã dừng lại',
        successHeading: 'Đặt mật khẩu thành công',
      },
      noReports: {
        description:
          'Tất cả các báo cáo đã nộp sẽ được hiển thị ở đây. Tìm hiểu thêm về các cách bạn có thể nộp báo cáo trong',
        descriptionHelpArticle: 'bài viết hỗ trợ này',
        errorDescription:
          'Chúng tôi đang gặp khó khăn trong việc tải báo cáo của bạn. Vui lòng thử làm mới trang.',
        errorDescriptionSecondary:
          'Nếu điều đó không hoạt động, vui lòng liên hệ với chúng tôi tại',
        errorTitle: '⚠️ Ồ, có gì đó đã sai',
        title: 'Bạn chưa có báo cáo nào',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Kích hoạt dịch tự động và đọc tất cả các thông báo báo cáo bằng ngôn ngữ ưa thích của bạn. Ngôn ngữ được dịch dựa trên ngôn ngữ được chọn trên thiết bị của bạn.',
          autoTranslationDescription2:
            'Bạn có thể chuyển đổi giữa ngôn ngữ dịch và ngôn ngữ gốc trong mỗi cuộc trò chuyện.',
          autoTranslationTitle: 'Kích hoạt tự động dịch cho thông điệp báo cáo',
          header: 'Cài đặt tin nhắn',
          subHeader: 'Cấu hình cách hiển thị tin nhắn',
        },
        notificationSettings: {
          emailDescription:
            'Nhận thông báo qua email về các cập nhật quan trọng cho báo cáo của bạn',
          emailTitle: 'Thông báo qua Email',
          header: 'Cài đặt thông báo',
          subHeader: 'Cấu hình cách bạn nhận thông báo',
        },
        title: 'Cài đặt',
        updatedSettingsFailure: 'Không thể cập nhật cài đặt của bạn',
        updatedSettingsSuccess: 'Đã cập nhật thành công cài đặt của bạn',
      },
    },
    validators: {
      passwordLength: 'Mật khẩu phải dài ít nhất 9 ký tự',
      passwordLowercase: 'Mật khẩu phải chứa ít nhất 1 chữ cái viết thường',
      passwordMissMatch: 'Mật khẩu và các trường xác nhận phải khớp nhau.',
      passwordNumeric: 'Mật khẩu phải chứa ít nhất 1 số',
      passwordUppercase: 'Mật khẩu phải chứa ít nhất 1 chữ cái viết hoa',
    },
    validatorsNew: {
      passwordLength: 'Giữa 10 và 30 ký tự',
      passwordLowercase: 'Ít nhất một chữ cái viết thường',
      passwordMissMatch: 'Mật khẩu không khớp',
      passwordNumeric: 'Ít nhất một số',
      passwordSpecialCharacter: 'Ít nhất một ký tự đặc biệt',
      passwordUppercase: 'Ít nhất một chữ cái in hoa',
    },
  },
};

export default translations;
